export default __webpack_public_path__ + "static/media/edit-circle.6730040f.svg";